import NistFrameworkCategory from './NistFrameworkCategory'

export default NistFrameworkCategory
